import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-atlas-filter-field',
  templateUrl: './atlas-filter-field.component.html',
  styleUrls: ['./atlas-filter-field.component.scss'],
})
export class AtlasFilterFieldComponent {
  @Input({ required: true }) label = '';
  @Input() value: any;
  @Input() multiple = false;
  @Input() compact = false;
  @Input() choices: any[] = [];
  @Output() valueChange = new EventEmitter<any>();
}